"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ETicketSocketEvent = void 0;
var ETicketSocketEvent;
(function (ETicketSocketEvent) {
    ETicketSocketEvent["JoinRoom"] = "eticket:joinRoom";
    ETicketSocketEvent["LeaveRoom"] = "eticket:leaveRoom";
    ETicketSocketEvent["Ready"] = "eticket:ready";
    ETicketSocketEvent["TicketScanned"] = "eticket:ticketScanned";
})(ETicketSocketEvent || (exports.ETicketSocketEvent = ETicketSocketEvent = {}));
